<template>
  
      <!--====== APPIE HERO PART START ======-->
    
    <section class="appie-hero-area appie-hero-4-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-5">
                    <div class="appie-hero-content appie-hero-content-4">
                        <span>30 Days Free Trial</span>
                        <h1 class="appie-title">Get it done with appie.io</h1>
                        <p>Tosser lemon squeezy chancer hanky panky arse plastered show off show off pick your nose and blow knackered bugger porkies.</p>
                        <a class="main-btn" href="#">Let’s Talk</a>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="appie-hero-thumb appie-hero-thumb-4">
                        <img src="@/assets/images/hero-thumb-5.png" alt="">
                        <div class="hero-dot">
                            <img src="@/assets/images/hero-dot.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero-shape-1">
            <img src="@/assets/images/shape/shape-10.png" alt="">
        </div>
    </section>
    
    <!--====== APPIE HERO PART ENDS ======-->

</template>

<script>
export default {

}
</script>

<style>

</style>